import { css, styled } from '@lux/ds';

export interface INavButtonItemProps {
  margin?: boolean;
}

export const NavButtonItem = styled('div', {
  shouldForwardProp: prop => !['active', 'margin'].includes(prop as string),
})<INavButtonItemProps>(
  ({ theme, margin }) => css`
    border-radius: 4px;
    width: auto;
    height: 32px;
    color: ${theme.palette.primary.shade[40]};
    padding: ${theme.space.xs};
    box-sizing: border-box;
    cursor: pointer;
    display: flex;
    align-items: center;

    ${margin && 'margin-left: 40px'};

    :hover {
      background-color: ${theme.palette.primary.shade[90]};
    }
  `,
);
